/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMedalAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 1a1 1 0 0 0-1 1v6.333a1 1 0 0 0 .478.854l3.929 2.4a6 6 0 1 0 5.185 0l3.929-2.4a1 1 0 0 0 .478-.854V2a1 1 0 0 0-1-1h-8zm5 9.217V3h2v7.217l-1 .611zm6-2.444-2 1.222V3h2zM7 3h2v5.995L7 7.773zm1 14a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4.882-1.214L12 14l-.882 1.786-1.971.287 1.426 1.39-.336 1.964L12 18.5l1.763.927-.336-1.964 1.426-1.39z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMedalAlt as MedalAlt };
